import { string, shape } from 'prop-types';

export default shape({
  title: string.isRequired,
  uri: string.isRequired,
  streamKey: string.isRequired,
  env: shape({
    SCREEN_WIDTH: string,
    SCREEN_HEIGHT: string,
    VIDEO_FRAMERATE: string,
    VIDEO_BITRATE: string,
    AUDIO_BITRATE: string,
    AUDIO_SAMPLERATE: string,
    VIDEO_BUFSIZE: string,
    AUDIO_DELAY: string
  })
});
